import { isNil } from "lodash";

export const applyCSSSetting = (cssVariableKeyPrefix: string, cssVariableKey: string, value: any) => {
  if (isNil(value)) {
    document.documentElement.style.removeProperty(`--${cssVariableKeyPrefix}${cssVariableKey}`);
  } else {
    document.documentElement.style.setProperty(`--${cssVariableKeyPrefix}${cssVariableKey}`, value);
  }
};
